import { useSelector, useDispatch } from "react-redux";
import styles from "./layout.module.css";
import { enterpriseLevelsDetailsSelector } from "../../Reducers/enterpriseLevelsDetailsReducer";
import { enterpriseDetailsSelector } from "../../Reducers/enterpriseDetailsReducer";
import { getOrgNameBasedOnLevel } from "../../Util/dataHelper";
import Hamburger from "../Icons/hamburger";
import { leftSideBarSelector, LEFT_SIDE_BAR } from "../../Reducers/leftSideBarReducer";
import DownChevron from "../Icons/down-chevron";
import Avatar from "../CommonComponents/avatar/Avatar";
import { useRef, useState, useEffect } from "react";
import ProfilePopup from "./profilePopup";



const EnterpriseHeader = () => {
  const enterpriseLevelsDetails = useSelector(enterpriseLevelsDetailsSelector);
  const partnerDetails = useSelector(enterpriseDetailsSelector);
  const sideBarActive = useSelector(leftSideBarSelector);
  const dispatch = useDispatch();

  const handleHamburgerClick = () => {
    dispatch({
      type: LEFT_SIDE_BAR,
      payload: !sideBarActive,
    });
  };

  const [profileOpen, setProfileOpen] = useState(false);
  const pillRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    if (!profileOpen) return;
    const handleClickOutside = (event) => {
      if (
        pillRef.current &&
        !pillRef.current.contains(event.target) &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [profileOpen]);

  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerLeft}>
        <div className={styles.headerLeftIcon} onClick={handleHamburgerClick}>
            <Hamburger />
        </div>
        <div className={styles.headerLeftText}>{getOrgNameBasedOnLevel(partnerDetails, enterpriseLevelsDetails)}</div>
      </div>

      <div className={styles.headerRight}>
        <div
          className={styles.headerAccountPill}
          ref={pillRef}
          onClick={() => setProfileOpen((v) => !v)}
        >
          <Avatar name={partnerDetails.name} size={"32px"} variant="default" />
          <DownChevron />
        </div>
        {profileOpen && <ProfilePopup ref={popupRef} />}
      </div>
    </div>
  );
};
export default EnterpriseHeader;
